module.exports = __webpack_public_path__ + "media/customizations/riverstone/logo-6579034217d78671e370cd2cdf0ccba2.png";